export const getFieldLabel = (field: string): string => {
  switch (field) {
    case "tradePrice":
    case "PRICE":
      return "Trade Price";
    case "tradePriceQty":
    case "tradeVolume":
    case "VOLUME":
      return "Trade Qty";
    case "totalVolume":
      return "Volume";
    case "bidPrice":
      return "Bid Price";
    case "offerPrice":
      return "Offer Price";
    case "bidSize":
    case "bidPriceQty":
      return "Bid Qty";
    case "offerSize":
    case "offerPriceQty":
      return "Offer Qty";
    default:
      return field;
  }
};

export const isPriceField = (field: string): boolean =>
  ["tradePrice", "bidPrice", "offerPrice", "PRICE"].includes(field);

export const extractValueFromCondition = (
  condition: string,
): number | undefined => {
  if (!condition) return undefined;
  const match = condition.match(/([0-9.-]+)$/);
  return match ? parseFloat(match[1]) : undefined;
};
